import { jsPDF } from 'jspdf';
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import './CreateCV.css';
import Footer from './Footer';
import Header from './Header';
import { Helmet } from "react-helmet-async";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Localized months for selects
const MONTHS_SR = [
  'Januar','Februar','Mart','April','Maj','Jun',
  'Jul','Avgust','Septembar','Oktobar','Novembar','Decembar'
];

const EDUCATION_LEVELS = [
  "Osnovna Skola",
  "Srednja skola",
  "Fakultet",
  "Doktorat",
];




// Static constants (do not change between renders)
const languageOptions = [
  'Afrikaans',
  'Albanian',
  'Amharic',
  'Arabic',
  'Armenian',
  'Assamese',
  'Azerbaijani',
  'Bengali',
  'Bosnian',
  'Bulgarian',
  'Burmese',
  'Cantonese',
  'Catalan',
  'Cebuano',
  'Chechen',
  'Croatian',
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'Esperanto (constructed language)',
  'Estonian',
  'Finnish',
  'French',
  'Georgian',
  'German',
  'Greek',
  'Gujarati',
  'Haitian Creole',
  'Hausa',
  'Hebrew',
  'Hindi',
  'Hungarian',
  'Icelandic',
  'Igbo',
  'Indonesian',
  'Irish (Gaelic)',
  'Italian',
  'Japanese',
  'Javanese',
  'Kannada',
  'Kazakh',
  'Khmer',
  'Korean',
  'Kurdish',
  'Kyrgyz',
  'Lao',
  'Latin (classical, not widely spoken today but still recognized)',
  'Latvian',
  'Lithuanian',
  'Luxembourgish',
  'Macedonian',
  'Malay',
  'Malayalam',
  'Mandarin Chinese (the most spoken language by number of native speakers)',
  'Marathi',
  'Mongolian',
  'Montenegrin',
  'Nepali',
  'Norwegian',
  'Oriya',
  'Pashto',
  'Persian (Farsi)',
  'Polish',
  'Portuguese',
  'Punjabi',
  'Romanian',
  'Russian',
  'Serbian',
  'Sindhi',
  'Sinhala',
  'Slovak',
  'Slovene (Slovenian)',
  'Somali',
  'Spanish',
  'Swahili',
  'Swedish',
  'Tagalog (Filipino)',
  'Tajik',
  'Tamil',
  'Telugu',
  'Thai',
  'Tigrinya',
  'Turkish',
  'Turkmen',
  'Ukrainian',
  'Urdu',
  'Uzbek',
  'Vietnamese',
  'Welsh',
  'Wolof',
  'Xhosa',
  'Yoruba',
  'Zulu'
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 1940 + 1 }, (_, i) =>
  (1940 + i).toString()
);
const months = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];
const levelsOfEducation = [
  'Osnovna Škola',
  'Srednja Škola (3 godine)',
  'Srednja Škola (4 godine)',
  'Bačelor Diploma',
  'Master Diploma',
  'Doktorat'
];

const LanguageRating = ({ value = 0, onChange, name }) => {
  return (
    <div className="rating" role="radiogroup" aria-label="Nivo govora (1 do 5)">
      {[1,2,3,4,5].map((n, i) => (
        <label key={n} className={`rating-dot ${n <= Number(value) ? 'active' : ''}`}>
          <input
            type="radio"
            name={name}
            value={n}
            checked={Number(value) === n}
            onChange={() => onChange(n)}
            required={i === 0}
          />
          <span className="dot" aria-hidden="true" />
          <span className="sr-only">{n} od 5</span>
        </label>
      ))}
      <span className="rating-text">{Number(value) || 0}/5</span>
    </div>
  );
};

function CV() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    city: '',
    country: '',
    phoneNumber: '',
    email: '',
    photo: null, //3/6
    experiences: [
      {
        companyName: '',
        positionName: '',
        startYear: '',
        startMonth: '',
        endYear: '',
        endMonth: '',
        isEmployed: false,
        workDescription: ''
      }
    ],
    education: [
      {
        level: '',
        schoolName: '',
        fieldOfStudy: '',
        startYear: '',
        endYear: ''
      }
    ],
    languages: [
      {
        name: '',
        proficiency: 0 
      }
    ],
    skills: []
  });


const fileInputRef = useRef(null);



const handleDownloadCV = () => {
const formElement = document.querySelector('.cv-form');
if (!formElement.checkValidity()) {
  const firstInvalidField = formElement.querySelector(':invalid');
  if (firstInvalidField) {
    firstInvalidField.scrollIntoView({ behavior: "smooth", block: "center" });
    firstInvalidField.focus();
    toast.error("Molimo popunite sva obavezna polja.");
  }
  return;
}


if (!/^\+\d{9,}$/.test(formData.phoneNumber)) {
  const phoneInput = document.querySelector('input[name="phoneNumber"]');
  if (phoneInput) {
    phoneInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
    phoneInput.focus();
  }
  toast.error("Unesite ispravan broj telefona (npr: +38268123456).");
  return;
}


  // Load logo image
  const logo = new Image();
  logo.src = process.env.PUBLIC_URL + '/images/StarLogo.jpg';

  function drawRatingCircles(doc, x, y, level, { r = 1.6, gap = 4, outline = 0.25 } = {}) {
  const oldLW = doc.getLineWidth?.() || 0.2;
  doc.setLineWidth(outline);
  doc.setDrawColor(40);   // outline color
  doc.setFillColor(0);    // fill color (black)

  for (let i = 1; i <= 5; i++) {
    const cx = x + (i - 1) * (2 * r + gap);
    // filled if i <= level, outline-only otherwise
    doc.circle(cx, y, r, i <= level ? 'FD' : 'S');
  }

  doc.setLineWidth(oldLW);
}



  logo.onload = () => {
    // Convert logo to base64
    const canvas = document.createElement('canvas');
    canvas.width = logo.width;
    canvas.height = logo.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(logo, 0, 0);
    const base64Logo = canvas.toDataURL('image/jpeg');

    // --- Begin PDF Generation ---
    const doc = new jsPDF();
    const pageWidth = 210;
    const pageHeight = 297;
    const margin = 20;
    let currentY = margin;
    

    let isFirstPage = true;

    // // Helper: page break check
    // function checkPageBreak(addedHeight) {
    //   if (currentY + addedHeight > pageHeight - margin) {
    //     doc.addPage();
    //     currentY = margin;
    //   }
    // }
    function checkPageBreak(addedHeight) {
  if (currentY + addedHeight > pageHeight - margin) {
    doc.addPage();
    currentY = margin;
    isFirstPage = false;
  }
}

    // Draw header bar
doc.setFillColor(36, 30, 32); // #241e20
doc.rect(0, 0, pageWidth, 30, 'F');

doc.setTextColor(255, 255, 255);
doc.setFontSize(22);
doc.setFont('helvetica', 'bold');
doc.text('Curriculum Vitae', margin + 2, 20);
doc.setTextColor(0, 0, 0);

    // ✅ Draw the logo in top-right corner
    //const logoWidth = 30;
    const logoHeight = 30;
    //doc.addImage(base64Logo, 'JPEG', pageWidth - margin - logoWidth, 10, logoWidth, logoHeight);

  //   if (isFirstPage) {
  //   const logoWidth = 30;
  //   const logoHeight = 30;
  //   const logoX = pageWidth - margin - logoWidth;
  //   const logoY = 10;
  //   doc.addImage(base64Logo, 'JPEG', logoX, logoY, logoWidth, logoHeight);
  // }
  if (isFirstPage) {
  const logoWidth = 30;
  const logoHeight = 30;
const logoX = pageWidth - margin - logoWidth;

  const logoY = 0; // inside the header

  // Optional: cover the background if the logo isn't transparent
  doc.setFillColor(36, 30, 32); // exact match to #241e20

  doc.rect(logoX, logoY, logoWidth, logoHeight, 'F');

  // Draw the logo
  doc.addImage(base64Logo, 'JPEG', logoX, logoY, logoWidth, logoHeight);
}


    currentY = Math.max(40, 10 + logoHeight + 10); // Adjust for logo overlap

    // Add Photo (if any)
    if (formData.photo) {
      const imageType = formData.photo.includes('image/png') ? 'PNG' : 'JPEG';
      const imageWidth = 40;
      const imageHeight = 40;
      doc.addImage(formData.photo, imageType, (pageWidth - imageWidth) / 2, currentY, imageWidth, imageHeight);
      currentY += imageHeight + 10;
    }

    // === Personal Info Section ===
    const headerHeight = 10;
    doc.setFillColor(230, 230, 230);
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.rect(margin, currentY, pageWidth - 2 * margin, headerHeight, 'F');
    doc.text('Licne Informacije', margin + 2, currentY + 7);
    currentY += headerHeight + 5;

    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Ime i prezime: ${formData.firstName} ${formData.lastName}`, margin, currentY); currentY += 7;
    doc.text(`Datum rodjenja:: ${formData.dateOfBirth}`, margin, currentY); currentY += 7;
    doc.text(`Grad: ${formData.city}`, margin, currentY); currentY += 7;
    doc.text(`Drzava: ${formData.country}`, margin, currentY); currentY += 7;
    doc.text(`Broj telefona: ${formData.phoneNumber}`, margin, currentY); currentY += 7;
    // doc.text(`Email: ${formData.email}`, margin, currentY); currentY += 10;

    const emailText = `Email: ${formData.email}`;
    const emailLines = doc.splitTextToSize(emailText, pageWidth - 2 * margin);
    doc.text(emailLines, margin, currentY);
    currentY += emailLines.length * 7;


    doc.line(margin, currentY, pageWidth - margin, currentY);
    currentY += 5;

    // === Education Section ===
    doc.setFillColor(230, 230, 230);
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.rect(margin, currentY, pageWidth - 2 * margin, headerHeight, 'F');
    doc.text('Obrazovanje', margin + 2, currentY + 7);
    currentY += headerHeight + 5;

    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    formData.education.forEach((edu) => {
      doc.text(`Nivo obrazovanja: ${edu.level}`, margin, currentY); currentY += 7;
      doc.text(`Ime obrazovne institucije: ${edu.schoolName}`, margin, currentY); currentY += 7;
      doc.text(`Smjer obrazovanja: ${edu.fieldOfStudy}`, margin, currentY); currentY += 7;
      doc.text(`Godina pocetka i zavrsetka obrazovanja: ${edu.startYear} - ${edu.endYear}`, margin, currentY); currentY += 10;
    });
    doc.line(margin, currentY, pageWidth - margin, currentY); currentY += 5;

    // === Work Experience ===
    doc.setFillColor(230, 230, 230);
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.rect(margin, currentY, pageWidth - 2 * margin, headerHeight, 'F');
    doc.text('Radno iskustvo', margin + 2, currentY + 7);
    currentY += headerHeight + 5;

    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    formData.experiences.forEach((exp) => {
      doc.text(`Ime kompanije: ${exp.companyName}`, margin, currentY); currentY += 7;
      doc.text(`Ime pozicije: ${exp.positionName}`, margin, currentY); currentY += 7;
      const startLabel = exp.startMonth ? `${exp.startMonth} ${exp.startYear}` : exp.startYear;
      const endLabel = exp.isEmployed
        ? 'Sada'
        : (exp.endMonth ? `${exp.endMonth} ${exp.endYear}` : exp.endYear);

      doc.text(`Period rada: ${startLabel} - ${endLabel}`, margin, currentY);
      currentY += 7;

      const desc = (exp.workDescription || '').trim();
      if (desc) {
        const lines = doc.splitTextToSize(
          `Kratak opis posla: ${desc}`,
          pageWidth - 2 * margin
        );
        checkPageBreak(lines.length * 7);
        doc.text(lines, margin, currentY);
        currentY += lines.length * 7 + 5;
      } else {
        currentY += 5; // small spacer for consistent spacing
      }
    });
    doc.line(margin, currentY, pageWidth - margin, currentY); currentY += 5;

    // === Skills ===
// === Skills Section ===
    checkPageBreak(headerHeight + 5);
    doc.setFillColor(230, 230, 230);
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.rect(margin, currentY, pageWidth - 2 * margin, headerHeight, 'F');
    doc.text('Vjestine', margin + 2, currentY + 7);
    currentY += headerHeight + 5;

    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    const skillsText = formData.skills; 
    const skillsLines = doc.splitTextToSize(skillsText, pageWidth - 2 * margin);

    // ✅ Make sure there's enough room for the text
    checkPageBreak(skillsLines.length * 7);

    doc.text(skillsLines, margin, currentY);
    currentY += skillsLines.length * 7;
    doc.line(margin, currentY, pageWidth - margin, currentY); currentY += 5;


    
    // === Languages ===

// === Languages ===
checkPageBreak(headerHeight + 5 + formData.languages.length * 7);

doc.setFillColor(230, 230, 230);
doc.setFontSize(14);
doc.setFont('helvetica', 'bold');
doc.rect(margin, currentY, pageWidth - 2 * margin, headerHeight, 'F');
doc.text('Jezici', margin + 2, currentY + 7);
currentY += headerHeight + 5;

doc.setFontSize(12);
doc.setFont('helvetica', 'normal');

formData.languages.forEach((lang) => {
  const level = Number(lang.proficiency) || 0;

  // label line
  doc.text(`Jezik: ${lang.name || ''} - Nivo: ${level}/5`, margin, currentY);

  // small circles to the right of the label line
  drawRatingCircles(doc, margin + 65, currentY - 2, level, { r: 1.6, gap: 4, outline: 0.25 });

  currentY += 7;
});


doc.line(margin, currentY, pageWidth - margin, currentY);
currentY += 5;



    // Save final PDF
    //doc.save('cv.pdf');
    // Save final PDF (safe cleanup)
    const blob = doc.output('blob');
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = 'cv.pdf';
    document.body.appendChild(link);

    // Trigger download
    link.click();

    // Cleanup once after click completes
    setTimeout(() => {
      if (link.isConnected) link.remove();     // or: document.body.removeChild(link) if you prefer
      URL.revokeObjectURL(blobUrl);
    }, 0);

    // Optional: Safari heads-up (no extra remove/revoke here!)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      toast.info('Za korisnike Safari pretraživača: Kada se fajl otvori, kliknite Share → Save to Files za preuzimanje CV-a.');
    }



      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);

    toast.success("Preuzeli ste vaš CV!");

    setFormData({
      firstName: "",
      lastName: "",
      dateOfBirth: "",
      city: "",
      country: "",
      phoneNumber: "",
      email: "",
      photo: null,
      experiences: [
        {
          companyName: "",
          positionName: "",
          startYear: "",
          startMonth: "",
          endYear: "",
          endMonth: "",
          isEmployed: false,
          workDescription: ""
        }
      ],
      education: [
        {
          level: "",
          schoolName: "",
          fieldOfStudy: "",
          startYear: "",
          endYear: ""
        }
      ],
      languages: [
        {
          name: "",
          proficiency: ""
        }
      ],
      skills: ""
    });

    if (fileInputRef.current) {
    fileInputRef.current.value = null;
    }

  };
};
  // Handlers for languages, experience, education, etc.
  const handleLanguageChange = (index, e) => {
    const { name, value } = e.target;
    const updatedLanguages = [...formData.languages];
    updatedLanguages[index][name] = name === 'proficiency' ? parseInt(value) : value;
    setFormData({ ...formData, languages: updatedLanguages });
  };

  const addLanguage = () => {
    setFormData({
      ...formData,
      languages: [...formData.languages, { name: '', proficiency: 0 }]
    });
  };

  const removeLanguage = (index) => {
    const updatedLanguages = formData.languages.filter((_, i) => i !== index);
    setFormData({ ...formData, languages: updatedLanguages });
  };

const handleExperienceChange = (index, e) => {
  const { name, value, checked } = e.target;
  const updated = [...formData.experiences];

  if (name === 'isEmployed') {
    updated[index].isEmployed = checked;
    if (checked) {
      updated[index].endYear = '';
      updated[index].endMonth = '';
    }
  } else {
    updated[index][name] = value;
  }

  setFormData({ ...formData, experiences: updated });
};


  // New: Handler for optional photo upload 3/6
const handlePhotoChange = (e) => {
  const file = e.target.files[0];

  if (file && file.size > 5 * 1024 * 1024) { // >5MB
    toast.error("Slika je prevelika. Maksimalna veličina je 5MB.");
    return;
  }

  if (file) {
    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData({ ...formData, photo: reader.result });
      toast.success("Slika uspješno dodata!");
    };
    reader.readAsDataURL(file);
  } else {
    setFormData({ ...formData, photo: null });
  }
};




  const addExperience = () => {
    setFormData({
      ...formData,
      experiences: [
        ...formData.experiences,
        {
          companyName: '',
          positionName: '',
          startYear: '',
          startMonth: '',
          endYear: '',
          endMonth: '',
          isEmployed: false,
          workDescription: ''
        }
      ]
    });
  };

  const removeExperience = (index) => {
    const updatedExperiences = formData.experiences.filter((_, i) => i !== index);
    setFormData({ ...formData, experiences: updatedExperiences });
  };

  const handleEducationChange = (index, e) => {
    const { name, value } = e.target;
    const updatedEducation = [...formData.education];
    updatedEducation[index][name] = value;
    setFormData({ ...formData, education: updatedEducation });
  };

  const addEducation = () => {
    setFormData({
      ...formData,
      education: [
        ...formData.education,
        { level: '', schoolName: '', fieldOfStudy: '', startYear: '', endYear: '' }
      ]
    });
  };

  const removeEducation = (index) => {
    const updatedEducation = formData.education.filter((_, i) => i !== index);
    setFormData({ ...formData, education: updatedEducation });
  };

  return (
    <>
    <Helmet>
      <title>Napravi CV Online | Sezonski Poslovi Star</title>
      <meta
        name="description"
        content="Kreirajte profesionalni CV online i preuzmite ga kao PDF. Brzo, jednostavno i besplatno."
      />
      <meta
        name="keywords"
        content="CV, resume, napravi CV, PDF, posao, prijava, Sezonski Poslovi Star"
      />
      <meta property="og:title" content="Napravi CV Online | Sezonski Poslovi Star" />
      <meta
        property="og:description"
        content="Kreirajte svoj CV online i preuzmite ga kao PDF dokument. Jednostavno i brzo uz Sezonski Poslovi Star."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.starjobs.com/create-cv" />
      <meta property="og:image" content="/images/seo-banner.jpg" />
    </Helmet>

      {/* <div className="cv-header-container">
        <div className="cv-header">
          <div className="cv-tabs">
            <Link to="/" className="tab">Home</Link>
            <Link to="/jobs-page" className="tab">Jobs</Link>
            <Link to="/fastApplication" className="tab">Fast Application</Link>
            <Link to="/create-cv" className="tab">Create CV</Link>
          </div>
        </div>
      </div> */}
      <Header />
      <div className="create-cv-bg-wrapper">
        <div className="create-cv-container">
          <div className="Or-word">
            <h2>Nemate CV / Rezime? Napravite ga ovdje!</h2>
          </div>
          <form className="cv-form">
            {/* Personal Information */}
            <div className="section">
            <div className="form-group">
              <h3>Lične Informacije</h3>
              <label htmlFor="firstName">Ime:</label>
              <input
                id="firstName"
                type="text"
                name="firstName"
                placeholder="Npr: Marko"
                value={formData.firstName}
                onChange={(e) => {
                  const filtered = e.target.value.replace(/[^a-zA-Z]/g, '');
                  if (filtered.length <= 20) {
                    setFormData({ ...formData, firstName: filtered });
                  }
                }}
                required
              />
              <label htmlFor="lastName">Prezime:</label>
              <input
                type="text"
                name="lastName"
                placeholder="Npr: Markovic"
                value={formData.lastName}
                onChange={(e) => {
                  const filtered = e.target.value.replace(/[^a-zA-Z]/g, '');
                  if (filtered.length <= 20) {
                    setFormData({ ...formData, lastName: filtered });
                  }
                }}
                required
              />
              <label htmlFor="dateOfBirth">Datum rodjenja:</label>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={(e) => {
                  setFormData({ ...formData, dateOfBirth: e.target.value });
                }}
                required
                max="9999-12-31"
              />
              <label htmlFor="city">Grad:</label>
              <input
                type="text"
                name="city"
                placeholder="Npr: Podgorica"
                value={formData.city}
                onChange={(e) => {
                  const filtered = e.target.value.replace(/[^a-zA-Z ]/g, '');
                  if (filtered.length <= 20) {
                    setFormData({ ...formData, city: filtered });
                  }
                }}
                required
              />
              <label htmlFor="country">Država:</label>
              <input
                type="text"
                name="country"
                placeholder="Npr: Crna Gora"
                value={formData.country}
                onChange={(e) => {
                  const filtered = e.target.value.replace(/[^a-zA-Z ]/g, '');
                  if (filtered.length <= 20) {
                    setFormData({ ...formData, country: filtered });
                  }
                }}
                required
              />
              <label htmlFor="phoneNumber">Broj telefona:</label>
              <input
                type="tel"
                name="phoneNumber"
                placeholder="Npr: +38268123456"
                value={formData.phoneNumber}
                onChange={(e) => {
                  let val = e.target.value;
                  if (!val.startsWith('+')) {
                    val = '+' + val.replace(/[^0-9]/g, '');
                  } else {
                    val = '+' + val.slice(1).replace(/[^0-9]/g, '');
                  }
                  if (val.length <= 21) {
                    setFormData({ ...formData, phoneNumber: val });
                  }
                }}
                required
              />
              <>
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Npr: markomarkovic@gmail.com"
                  value={formData.email}
                  onChange={(e) => {
                    let val = e.target.value;

                    // Optional: restrict to safe characters
                    val = val.replace(/[^a-zA-Z0-9@._+-]/g, '');

                    if (val.length > 254) {
                      val = val.slice(0, 254);
                    }

                    setFormData({ ...formData, email: val });
                  }}
                  required
                />


                <label htmlFor="photo">
                  Dodajte sliku ( Nije obavezno ):
                  <span
                    className="info-icon"
                    title="For best results, please use a 500x500 pixels image to ensure HD quality."
                  >
                    i
                  </span>
                </label>
                <input
                  id="photo"
                  type="file"
                  name="photo"
                  accept="image/*"
                  ref={fileInputRef} 
                  onChange={handlePhotoChange}
                />


              </>
            </div>
            </div>

            {/* Work Experience */}
            <div className="section">
              <h3>Radno Iskustvo</h3>
              {formData.experiences.map((experience, index) => (
                <div key={index} className="experience-section">
                  <div className="form-group">
                    <label htmlFor={`companyName_${index}`}>Ime kompanije:</label>
                    <input
                      id={`companyName_${index}`}
                      type="text"
                      name="companyName"
                      placeholder="Npr: HD Laković DOO"
                      value={experience.companyName}
                      onChange={(e) => {
                        const filtered = e.target.value.replace(/[^a-zA-Z0-9 .-]/g, '');
                        if (filtered.length <= 50) {
                          handleExperienceChange(index, { target: { name: e.target.name, value: filtered } });
                        }
                      }}
                      required
                    />
                    <label htmlFor={`positionName_${index}`}>Ime pozicije:</label>
                    <input
                      id={`positionName_${index}`}
                      type="text"
                      name="positionName"
                      placeholder="Npr: Magacionier"
                      value={experience.positionName}
                      onChange={(e) => {
                        const filtered = e.target.value.replace(/[^a-zA-Z0-9 .-]/g, '');
                        if (filtered.length <= 50) {
                          handleExperienceChange(index, { target: { name: e.target.name, value: filtered } });
                        }
                      }}
                      required
                    />
                  </div>
                    <div className="year-fields">
                  {/* Start Month */}
                  <div className="form-group">
                    <label htmlFor={`startMonth_${index}`}>Mjesec početka rada:</label>
                    <select
                      id={`startMonth_${index}`}
                      name="startMonth"
                      value={experience.startMonth}
                      onChange={(e) => handleExperienceChange(index, e)}
                      required
                    >
                      <option value="" disabled>Izaberite mjesec</option>
                      {MONTHS_SR.map((m) => (
                        <option key={m} value={m}>{m}</option>
                      ))}
                    </select>
                  </div>

                  {/* Start Year */}
                  <div className="form-group">
                    <label htmlFor={`startYear_${index}`}>Godina početka rada:</label>
                    <input
                      type="text"
                      id={`startYear_${index}`}
                      name="startYear"
                      placeholder="Npr: 2020"
                      value={experience.startYear}
                      onChange={(e) => {
                        const filtered = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
                        handleExperienceChange(index, { target: { name: 'startYear', value: filtered } });
                      }}
                      required
                    />
                  </div>

                  {/* End Month */}
                  <div className="form-group">
                    <label htmlFor={`endMonth_${index}`}>Mjesec završetka rada:</label>
                    <select
                      id={`endMonth_${index}`}
                      name="endMonth"
                      value={experience.endMonth}
                      onChange={(e) => handleExperienceChange(index, e)}
                      disabled={experience.isEmployed}
                      required={!experience.isEmployed}
                    >
                      <option value="" disabled>Izaberite mjesec</option>
                      {MONTHS_SR.map((m) => (
                        <option key={m} value={m}>{m}</option>
                      ))}
                    </select>
                  </div>

                  {/* End Year */}
                  <div className="form-group">
                    <label htmlFor={`endYear_${index}`}>Godina završetka rada:</label>
                    <input
                      type="text"
                      id={`endYear_${index}`}
                      name="endYear"
                      placeholder="Npr: 2023"
                      value={experience.endYear}
                      onChange={(e) => {
                        const filtered = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
                        handleExperienceChange(index, { target: { name: 'endYear', value: filtered } });
                      }}
                      disabled={experience.isEmployed}
                      required={!experience.isEmployed}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor={`isEmployed_${index}`} className="checkbox-container">
                      <input
                        id={`isEmployed_${index}`}
                        type="checkbox"
                        name="isEmployed"
                        checked={experience.isEmployed}
                        onChange={(e) => handleExperienceChange(index, e)}
                      />
                      Zaposlen i dalje u ovoj kompaniji
                    </label>
                  </div>
                </div>


                  <div className="form-group">
                    <label htmlFor={`workDescription_${index}`}>Kratak opis posla (nije obavezno):</label>
                    <textarea
                      name="workDescription"
                      placeholder="Npr: Duznosti su mi bile Radio sam sa Bio sam odgovoran za"
                      value={experience.workDescription}
                      onChange={(e) => {
                        const cleaned = e.target.value
                           .replace(/[^a-zA-Z0-9čćžšđČĆŽŠĐ.,\-\/ ]/g, '')
                          .slice(0, 65); // max 65 characters

                        handleExperienceChange(index, {
                          target: { name: 'workDescription', value: cleaned }
                        });
                      }}
                      maxLength="65"
                      rows="3"
                    />
                  </div>
                  {index > 0 && (
                    <button
                      type="button"
                      onClick={() => removeExperience(index)}
                      className="remove-btn"
                    >
                      Obriši
                    </button>
                  )}
                </div>
              ))}
              <button type="button" onClick={addExperience} className="add-btn">
                Dodaj Iskustvo
              </button>
            </div>

            {/* Education */}
            <div className="section">
              <h3>Obrazovanje</h3>
              {formData.education.map((edu, index) => (
                <div key={index} className="education-section">
                  <div className="form-group">
                  <label htmlFor={`eduLevel_${index}`}>Nivo obrazovanja:</label>
                  <select
                    id={`eduLevel_${index}`}
                    name="level"
                    value={edu.level}
                    onChange={(e) => handleEducationChange(index, e)}
                    required
                  >
                    <option value="" disabled>Izaberite nivo</option>
                    {EDUCATION_LEVELS.map((lvl) => (
                      <option key={lvl} value={lvl}>{lvl}</option>
                    ))}
                  </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor={`schoolName_${index}`}>Ime obrazovne institucije:</label>
                    <input
                      id={`schoolName_${index}`}
                      type="text"
                      name="schoolName"
                      placeholder="Npr: Srednja Elektrotehnička Škola Vaso Aligrudić"
                      value={edu.schoolName}
                      onChange={(e) => {
                        const filtered = e.target.value.replace(/[^a-zA-Z0-9 .-]/g, '');
                        if (filtered.length <= 50) {
                          handleEducationChange(index, { target: { name: e.target.name, value: filtered } });
                        }
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor={`fieldOfStudy_${index}`}>Smjer obrazovanja:</label>
                    <input
                      id={`fieldOfStudy_${index}`}
                      type="text"
                      name="fieldOfStudy"
                      placeholder="Npr: Elektronika / Energetika"
                      value={edu.fieldOfStudy}
                      onChange={(e) => {
                        const filtered = e.target.value.replace(/[^a-zA-Z0-9 .-]/g, '');
                        if (filtered.length <= 50) {
                          handleEducationChange(index, { target: { name: e.target.name, value: filtered } });
                        }
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor={`eduStartYear_${index}`}>Godina početka obrazovanja:</label>
                    <input
                      type="text"
                      id={`eduStartYear_${index}`}
                      name="startYear"
                      placeholder="Npr: 2016"
                      value={edu.startYear}
                      onChange={(e) => {
                        const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
                        const updatedEducation = [...formData.education];
                        updatedEducation[index].startYear = val;
                        setFormData({ ...formData, education: updatedEducation });
                      }}
                      required
                    />

                  </div>

                  <div className="form-group">
                    <label htmlFor={`eduEndYear_${index}`}>Godina završetka obrazovanja:</label>
                    <input
                      type="text"
                      id={`eduEndYear_${index}`}
                      name="endYear"
                      placeholder="Npr: 2020"
                      value={edu.endYear}
                      onChange={(e) => {
                        const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
                        const updatedEducation = [...formData.education];
                        updatedEducation[index].endYear = val;
                        setFormData({ ...formData, education: updatedEducation });
                      }}
                      required
                    />
                  </div>

                  {index > 0 && (
                    <button
                      type="button"
                      onClick={() => removeEducation(index)}
                      className="remove-btn"
                    >
                      Obriši
                    </button>
                  )}
                </div>
              ))}
              <button type="button" onClick={addEducation} className="add-btn">
                Dodaj Obrazovanje
              </button>
            </div>

            {/* Skills */}
            <div className="section">
              <h3>Vještine</h3>
              <div className="section-skills">
                <div className="form-group">
                  <label htmlFor="skills">Unesite vještine:</label>
                  <input
                    id="skills"
                    type="text"
                    name="skills"
                    placeholder="Npr: Komunikativan, Timski, Odgovoran"
                    value={formData.skills}
                    onChange={(e) => {
                      const cleaned = e.target.value
                         .replace(/[^a-zA-Z0-9čćžšđČĆŽŠĐ.,\-\/ ]/g, '')
                        .slice(0, 65); // max 65 characters
                      setFormData({ ...formData, skills: cleaned });
                    }}
                    required
                  />

                </div>
              </div>
            </div>

            {/* Languages */}
            <div className="section">
              <h3>Jezici</h3>
              {formData.languages.map((language, index) => (
                <div key={index} className="language-section">
                  <div className="form-group">
                    <label htmlFor={`languageName_${index}`}>Jezik:</label>
                    <input
                      type="text"
                      id={`languageName_${index}`}
                      name="name"
                      placeholder="Npr: Engleski"
                      value={language.name}
                      onChange={(e) => {
                        const filtered = e.target.value.replace(/[^a-zA-ZčćžšđČĆŽŠĐ ]/g, '').slice(0, 30);
                        handleLanguageChange(index, { target: { name: 'name', value: filtered } });
                      }}
                      required
                    />
                  </div>
                  <div className="form-group">
<label>Nivo govora:</label>
<LanguageRating
  value={language.proficiency}
  name={`lang-level-${index}`}
  onChange={(val) => {
    const updated = [...formData.languages];
    updated[index].proficiency = val; // store 1..5
    setFormData({ ...formData, languages: updated });
  }}
/>




                  </div>
                  <div className="buttons">
                    {index > 0 && (
                      <button
                        type="button"
                        onClick={() => removeLanguage(index)}
                        className="remove-btn"
                      >
                        Obriši
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <button type="button" onClick={addLanguage} className="add-btn">
              Dodaj jezik
            </button>
          </form>
          <button onClick={handleDownloadCV} className="download-cv-button">
            PREUZMI CV / REZIME
          </button>
        </div>
        </div>
      <Footer />
          <ToastContainer
            position="top-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
    </>
    
  );
}

export default CV;